import {
  cn as packageCn,
  en as packageEn,
  jp as packageJp,
  tw as packageTw,
} from '@eureka/utils/package-locale';

const cn = {
  commonProductPackage: packageCn,
};

const en = {
  commonProductPackage: packageEn,
};

const tw = {
  commonProductPackage: packageTw,
};

const jp = {
  commonProductPackage: packageJp,
};

const messages = {
  cn,
  en,
  tw,
  jp,
};

export default messages;
